module.exports = ".navigation .logo {\n  max-height: 80px;\n  padding: 5px; }\n\n.site-footer .logo {\n  max-height: 80px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.scss
// module id = ./src/app/home/home.component.scss
// module chunks = main